import React from "react";

import AOS from "aos";



  

const Aos = (duration) => {
    
       AOS.init({
            duration:duration,
            easing:"ease-in-out",
            once:false
        })

    
}
 
export default Aos;